comments-index
  comments-comment(each="{id in opts.comments}" tag-scope="comment_{id}")
  script(type="typescript").
    this.mixin('comments.index');
